import { productsObject } from "@/utils";

const uuidv4 = require("uuid/v4");

import ErrorHandlingMixin from "@/mixins/ErrorHandlingMixin";

export default {
  mixins: [ErrorHandlingMixin],
  methods: {
    // Saves given product in IndexedDB
    async saveProduct(product, project_uuid, product_model) {
      try {
        // Gets project from IndexedDB by uuid
        const project = await this.$store.dispatch(
          "projects/getLocalProject",
          project_uuid
        );

        // Generates a new product uuid
        product.uuid = uuidv4();
        product.projects_uuid = project.uuid;

        // Gets product table name
        const productTableName = productsObject[product_model].tableName;

        // Create product in IndexedDB
        const productKey = await this.$db[productTableName].add(product);

        // Gets saved product from IndexedDB
        const savedProduct = await this.$db[productTableName].get(productKey);

        // Gets old project product version
        const oldProductVersion = project.local_version
          ? project.local_version
          : project.server_version;

        // Deletes old product version from IndexedDB
        await this.$db[productTableName].delete(oldProductVersion);

        // Update project product version
        await this.$db.projects.update(project.uuid, {
          local_version: savedProduct.uuid,
          product_uuid: savedProduct.uuid
        });

        this.$notify({
          group: "main",
          type: "success",
          title: `La fiche ${
            productsObject[product_model].name
          } a bien été enregistrée`,
          duration: 5000
        });
      } catch (error) {
        this.handleError(error); // TODO: Log to server
      }
    }
  }
};
